module.exports = __webpack_public_path__ + "images/category_lp/common/reason3-woman-40_68c8e31130b00e727172dddd288206d9.jpg";